exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-5882d6f9]{position:fixed;top:0;left:0;right:0;bottom:0;background-color:#008bd0;z-index:800}.loader-container[data-v-5882d6f9]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;flex-direction:column;z-index:900;justify-content:center;align-items:center}.logo[data-v-5882d6f9]{margin-bottom:30px}.loader[data-v-5882d6f9]{background-color:#fff;height:85px;width:85px;border-radius:50%;text-align:center}.loader i[data-v-5882d6f9]{display:block;margin:0 auto}.loader i[data-v-5882d6f9]:before{content:\".\";animation-name:load-data-v-5882d6f9;animation-duration:.8s;animation-iteration-count:infinite;width:auto;color:#008bd0;display:inline-block;font-size:40px}@keyframes load-data-v-5882d6f9{0%{content:\".\"}33%{content:\"..\"}66%{content:\"...\"}to{content:\".\"}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5882d6f9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/Loader.vue
// module id = 399
// module chunks = 0